module.exports = __webpack_public_path__ + "static/media/contactFour.479e3778.jpeg";